module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "id": "shop-list-page"
    }
  }, [_c('div', {
    staticClass: "breadcrumb-layout"
  }, [_c('div', {
    staticClass: "breadcrumb wrapper"
  }, [_c('span', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("首页")])], 1), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_vm._v(">")]), _vm._v(" "), _c('span', [_vm._v("店铺")])])]), _vm._v(" "), _c('div', {
    staticClass: "container wrapper"
  }, [_c('div', {
    staticClass: "sort-bar"
  }, [_c('div', {
    staticClass: "shop_con_list",
    attrs: {
      "id": "main-nav-holder"
    }
  }, [_c('div', {
    staticClass: "sort-bar"
  }, [_c('div', {
    staticClass: "shop_con_list",
    attrs: {
      "id": "main-nav-holder"
    }
  }, [_c('nav', {
    staticClass: "nc-gl-sort-bar",
    attrs: {
      "id": "main-nav"
    }
  }, [_c('div', {
    staticClass: "sort-bar"
  }, [_c('ul', {
    staticClass: "array"
  }, [_c('li', {
    class: {
      'selected': _vm.searchType == 'default'
    },
    on: {
      "click": function($event) {
        return _vm.changeSearchByType('default')
      }
    }
  }, [_c('a', {
    staticClass: "nobg",
    attrs: {
      "href": "javascript:void(0)",
      "title": ""
    }
  }, [_vm._v("默认")])]), _vm._v(" "), _c('li', {
    class: {
      'selected': _vm.searchType == 'store_credit'
    },
    on: {
      "click": function($event) {
        return _vm.changeSearchByType('store_credit')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)",
      "title": "点击按信用从高到低排序"
    }
  }, [_vm._v("信用")])])])])])])])])]), _vm._v(" "), (_vm.list.length == 0 && !_vm.loading) ? _c('div', {
    staticClass: "squares"
  }, [_c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "20px",
      "text-align": "center"
    }
  }, [_vm._v("抱歉,暂无相关店铺!")])]) : _vm._e(), _vm._v(" "), _c('shop-list', {
    attrs: {
      "data": _vm.list
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.total > 0),
      expression: "total>0"
    }],
    staticClass: "page-wrapper"
  }, [_c('Page', {
    attrs: {
      "total": _vm.total,
      "current": _vm.page,
      "page-size": _vm.pageSize,
      "show-elevator": "",
      "show-total": ""
    },
    on: {
      "on-change": _vm.changePage
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a7b454b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/shop/shop-list.vue
// module id = 1542
// module chunks = 1